import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getWorkPeriodActions,
  resetStartEndWorkPeriod,
  startEndWorkPeriod,
} from "../redux/otherActions/workPeriodSlice";
import TableSkeleton from "../components/common/tableSkeleton";
import ErrorDisplay from "../components/common/error";
import ConfirmDialog from "../components/common/confirmDialog";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import useBranchGuard from "../hooks/useBranchGuard";
import { humanizeError } from "../utils/errorText";

const WorkPeriod = ({ className }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const branchUrl = useParams().id;
  useBranchGuard();

  const {
    loading: getLoading,
    success: getSuccess,
    error: getError,
    data,
  } = useSelector((state) => state.workPeriod.getWorkPeriod);
  const { loading, success, error } = useSelector(
    (state) => state.workPeriod.startWorkPeriod
  );
  const [workStat, setWorkStat] = useState("");
  // true = gün başı, false = gün sonu, null = onay penceresi kapalı
  const [pending, setPending] = useState(null);

  useEffect(() => {
    if (success) {
      toast.success(t("actions.workMsg", { workStat }), {
        position: "top-right",
      });
      dispatch(resetStartEndWorkPeriod());
      dispatch(getWorkPeriodActions({ branchUrl }));
    } else if (error) {
      toast.error(humanizeError(error, t), { position: "top-right" });
      dispatch(resetStartEndWorkPeriod());
    }
  }, [success, error, dispatch, workStat, t, branchUrl]);

  useEffect(() => {
    if (!data?.[branchUrl]) {
      dispatch(getWorkPeriodActions({ branchUrl }));
    }
  }, [dispatch, data, branchUrl]);

  const current = data?.[branchUrl];

  const requestWorkPeriod = (truthVal) => {
    if (current?.unPaidTickets?.length > 0) {
      toast.error(t("actions.!workMsg"), { position: "top-right" });
      return;
    }
    setPending(truthVal);
  };

  const confirmWorkPeriod = () => {
    const truthVal = pending;
    setPending(null);
    setWorkStat(truthVal ? t("actions.started") : t("actions.ended"));
    dispatch(startEndWorkPeriod({ branchUrl, truthVal }));
  };

  const buttonClass =
    "w-full text-left px-6 py-4 font-medium bg-[--primary] hover:bg-[--primary-hover] rounded-sm text-white disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[--primary]";

  return (
    <div className={`mb-6 sm:mb-4 ${className || ""}`}>
      <ConfirmDialog
        open={pending !== null}
        onClose={() => setPending(null)}
        onConfirm={confirmWorkPeriod}
        title={pending ? t("confirm.workStartTitle") : t("confirm.workEndTitle")}
        message={pending ? t("confirm.workStartMsg") : t("confirm.workEndMsg")}
        warning={pending ? null : t("confirm.workEndWarn")}
        confirmText={pending ? t("actions.start") : t("actions.end")}
        danger={pending === false}
      />

      {getLoading ? (
        <TableSkeleton />
      ) : getSuccess && current ? (
        <div className="w-full text-left text-[--gr-5]">
          <h2 className="px-6 py-1 font-medium text-lg max-sm:text-base bg-[--gr-4] text-slate-300">
            {t("nav.workPeriod")}
          </h2>
          <div className="gap-1 sm:gap-2 flex flex-col mt-2 max-sm:text-sm text-base">
            <button
              type="button"
              className={buttonClass}
              onClick={() => requestWorkPeriod(true)}
              disabled={current.workPeriodStart === true || loading}
            >
              {t("actions.start")}
            </button>
            <button
              type="button"
              className={buttonClass}
              onClick={() => requestWorkPeriod(false)}
              disabled={current.workPeriodStart === false || loading}
            >
              {t("actions.end")}
            </button>
          </div>
        </div>
      ) : getError ? (
        <ErrorDisplay
          error={getError}
          onRetry={() => dispatch(getWorkPeriodActions({ branchUrl }))}
        />
      ) : null}
    </div>
  );
};

export default WorkPeriod;
